import React from 'react';
import { useWatch } from 'react-hook-form';
import { ItemWithNotes } from './use-notes';
import { FormMode } from '../../../../enums/form-mode';
import { HiddenComponent } from '../../../../components/form/elements/hidden';
import edit from './edit.svg';
import css from '../index.module.css';

interface NotesProps {
  name: string;
  row: ItemWithNotes;
  editNotes: (row: ItemWithNotes) => void;
  mode: FormMode;
}

const Notes = ({ name, row, editNotes, mode }: NotesProps) => {
  const notes = useWatch({ name: `${name}.notes` });

  return mode !== FormMode.view || notes ? (
    <>
      <HiddenComponent name={`${name}.notes`} />
      <span onClick={() => editNotes(row)} className={css['edit-btn']}>
        <img src={edit} alt="edit" />
        {notes && <span className={css['notes-present']}></span>}
      </span>
    </>
  ) : null;
};

export default Notes;
